<template>
   <div class="scence">
    <div class="content">
      <!-- <div class="tabs">
        <div class="country" v-for="(item,index) in cusMulSelectData" :key="index">
            <span @click="setListCheck(index, item.value)" :class="[ choosed === index ? 'countryon' : '' ]">{{item.label}}</span>
        </div> -->
      <!-- </div> -->
      <!-- <cusMulSelect :name="name" :data="cusMulSelectData" :selectData.sync="selectData"></cusMulSelect> -->
      <div class="skt" ref="skt">
        <div class="select">
          <span class="xzqh">站名:</span>
          <div class="selcountry">
          <el-input
            placeholder="请输入站名"
            v-model="query.sTNM"
            @keyup.enter.native="onLoadData"
            class="filter-item"
            style="width: 150px;"
            clearable
             @change="Global.emptyQuery(query.sTNM,onLoadData)"
          ></el-input>
          </div>
          <span class="search" @click="onLoadData">查询</span>
        </div>
        <div class="tablebox">
          <div class="fzxxtable">
            <el-table :data="waterdata"  :span-method="objectSpanMethod" v-loading="loading" :max-height="height" border fit highlight-current-row style="width: 100%">
              <el-table-column type="index" width="60" align="center" label="序号"></el-table-column>
              <el-table-column align="center" label="站名" prop="stnm"></el-table-column>
              <el-table-column align="center" label="开始时间" prop="stlc">
                <template slot-scope="scope">
                  <span>{{ !scope.row.mstm ? '-' : scope.row.mstm }}</span>
                </template>
              </el-table-column>
              <el-table-column  label="结束时间" prop="ptno" min-width="70" align="center">
                <template slot-scope="scope">
                  <span>{{ !scope.row.ptno ? '-' : scope.row.ptno }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="汛限水位(m)" prop="rz" min-width="70">
                <template slot-scope="scope">
                  <span>{{ !scope.row.rz ? '-' : scope.row.rz }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="汛限库容" prop="w" min-width="70">
                <template slot-scope="scope">
                  <span>{{ !scope.row.w ? '-' : scope.row.w }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="汛限类别" prop="w" min-width="70">
                <template slot-scope="scope">
                  <span>{{ !scope.row.wsfa ? '-' : scope.row.wsfa }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" min-width="70" label="操作">
                <template slot-scope="scope" >
                  <div class="operation">
                    <!-- <span v-if="allowsPerm.update" class="edit" @click="onEdit(scope.row)"><span class="edit-icon"></span>编辑</span> -->
                    <span class="edit" @click="onEdit(scope.row)"><span class="edit-icon"></span>编辑</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            </div>
          </div>
      </div>
    </div>
    <el-dialog :title="diagTitle" :visible.sync="diagShow" :close-on-click-modal='false' class="abow_dialog" :class ="{river:isActive}">
      <el-form ref="userForm" :rules="rules" :model="form" label-width="90px">
        <el-form-item label="站名:" required>
          <el-form-item prop="userName">
            <el-input :disabled="true" v-model="form.stnm"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="施测时间:" required>
          <el-form-item prop="mstm">
            <el-input :disabled="true" v-model="form.mstm"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="点序号:" required v-if="query.sttp  === 'RR'">
          <el-form-item prop="ptno">
            <el-input v-model="form.ptno" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="库水位" required v-if="query.sttp === 'ZZ' ">
          <el-form-item prop="vigilance">
            <el-input v-model="form.vigilance" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="蓄水量" required v-if="query.sttp === 'ZZ' && swzjj === false">
          <el-form-item prop="w">
            <el-input v-model="form.w" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="水面面积:" required v-if="query.sttp  === 'ZZ'">
          <el-form-item prop="wsfa">
            <el-input v-model="form.wsfa" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
      <el-button @click ="onAdd(form.id)" type="primary" icon="el-icon-circle-plus" class="add-time" v-if="query.sttp === 'RR'">时段</el-button>
      <!-- 添加新增数据中的时间以下 -->
        <el-form ref='singleForm'
          class="time-floodlimit" v-for="(item,index) in singleData.floodLimit" :key="index" :model="item" >
         <el-form-item  label="时间分段:" required v-if="query.sttp  === 'RR'">
          <div class="time-block" style="display:flex;width:7.5rem;">
            <el-date-picker v-model="item.bgmd" :picker-options="Global.pickerOptionsStart(item.edmd)" required type="date" placeholder="开始日期" format=" MM-dd " value-format="MMdd">
            </el-date-picker>
            <div style="margin-left:5px;margin-right:5px">&nbsp;-&nbsp;</div>
           <el-date-picker v-model="item.edmd" :picker-options="Global.pickerOptionsEnd(item.bgmd)" required type="date" placeholder="结束日期" format=" MM-dd " value-format="MMdd">
           </el-date-picker>
          </div>
          </el-form-item>
        <el-form-item label="汛限水位:" required v-if="query.sttp  === 'RR'" >
          <el-form-item prop="floodLimit" id="floodLimit">
            <el-input v-model="item.fsltdz" required auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
         <div class="delete-icon">
          <i class="el-icon-delete" @click="onDelete(item, index)" style="cursor:pointer"></i>
         </div>
        </el-form>
         <!-- 添加新增数据中的时间以上 -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="diagShow = false">取消</el-button>
        <el-button type="primary" @click="onSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import userTypes from '@/store/types/user'
// import cusMulSelect from '@/components/CusMulSelect.vue'
export default {
  // components: { cusMulSelect },
  data () {
    return {
      stid: '',
      stcd: '',
      singleData: {},
      swzjj: false,
      name: '类型:',
      choosed: 0,
      selectData: '',
      loading: false,
      diagShow: false,
      diagTitle: '编辑',
      isActive: false, // 为水库时添加弹框类样式
      height: 200,
      form: {},
      query: {
        searchName: '',
        sTNM: '',
        sid: '22',
        pageIndex: 1,
        pageSize: 100,
        sttp: 'ZZ'
      },
      waterdata: [],
      spanArr: [],
      rules: {
        ensure: [
          { validator: this.Global.checkNumeral, trigger: 'blur' },
          { required: true, message: '请输入数字' }
        ],
        vigilance: [
          { validator: this.Global.checkNumeral, trigger: 'blur' },
          { required: true, message: '请输入数字' }
        ],
        floodLimit: [
          { validator: this.Global.checkNumeral, trigger: 'blur' },
          { required: true, message: '请输入数字' }
        ]
        // userName: [
        //   { required: true, message: '用户名不能为空' },
        //   { min: 4, message: '不能小于4个字符' }
        // ],
        // displayName: [
        //   { required: true, message: '姓名不能为空' }
        // ],
        // adcdCode: [
        //   { required: false, message: '请选择所在地区' }
        // ],
        // gender: [
        //   { required: false, message: '性别不能为空' }
        // ],
        // password: [
        //   { required: true, message: '密码不能为空', trigger: 'blur' }
        // ],
        // Roles: [
        //   { required: true, message: '角色不能为空', trigger: 'change' }
        // ]
      }
    }
  },
  watch: {
    'selectData': function (newVal) {
      if (newVal === 'ZZ') {
        this.query.sttp = 'ZZ'
      } else if (newVal === 'RR') {
        this.query.sttp = 'RR'
      }
      this.onLoadData()
    }
  },
  methods: {
    setListCheck (index, value) {
      this.choosed = index
      this.selectData = value
    },
    onLoadData () {
      this.loading = true
      this.$store.dispatch(userTypes.STATION_WARN_WATER_INFO, this.query).then(data => {
        this.waterdata = data.rows
        this.getSpanArr(data.rows)
        this.loading = false
      })
    },
    onEdit (row) {
      if (row.stnm.indexOf('水文站') !== -1) {
        this.swzjj = true
      } else {
        this.swzjj = false
      }
      if (this.query.sttp === 'ZZ') {
        this.isActive = true
        // this.diagTitle = '河道水位测站编辑'
      } else {
        this.isActive = false
        // this.diagTitle = '水库水位测站编辑'
      }
      this.form = {}
      if (this.query.sttp === 'RR') {
        this.$store.dispatch(userTypes.BACK_STATION_WARN_WATER_INFO, { sid: '22', stid: row.id, pageIndex: 1, pageSize: 100 }).then(data => {
          this.singleData = Object.assign({ floodLimit: [] }, data.rows[0]) // 当水库floodlimit为空时
          this.stcd = this.singleData.stcd
        })
      }
      this.stid = row.id
      this.form = row
      this.form = Object.assign({}, this.form) // 取消时
      this.Global.clearValidate(this, 'userForm')
      this.diagShow = true
    },
    onSave () {
      this.$refs['userForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          if (this.query.sttp === 'RR') { // 水库水位保存
            let callbackVal = this.singleData.floodLimit.every(element => { // 新增时段，起始时间为空不执行
              return element.bgmd !== '' || element.enmd !== ''
            })
            if (callbackVal) {
              this.$store.dispatch(userTypes.BATCH_SAVE_STATION_WARN_WATER_INFO, { List: this.singleData.floodLimit }).then(() => {
                this.$notify.success({ title: '成功', message: '编辑成功.' })
                this.diagShow = false
                this.onLoadData()
                this.loading = false
              })
            } else {
              this.$notify.error({ title: '保存失败', message: '起始时间不能为空' })
              this.loading = false
            }
          } else { // 河道保存
            let user = Object.assign({}, this.form)
            this.$store.dispatch(userTypes.SAVE_STATION_WARN_WATER_INFO, user).then(() => {
              this.$notify.success({ title: '成功', message: '编辑成功.' })
              this.diagShow = false
              this.onLoadData()
              this.loading = false
            })
          }
        }
      })
    },
    // 添加时间段设置
    onAdd (key) {
      this.singleData.floodLimit.push({
        id: '',
        stid: this.stid,
        stcd: this.stcd,
        fsltdz: '', // 汛限水位
        bgmd: '',
        enmd: ''
      })
    },
    // 删除对应时间段
    onDelete (item, i) {
      var index = this.singleData.floodLimit.indexOf(item)
      if (index !== -1) {
        this.singleData.floodLimit.splice(index, 1)
      }
    },
    getSpanArr (data) {
      this.spanArr = []
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1)
          this.pos = 0
        } else {
          if (data[i].stnm === data[i - 1].stnm) {
            this.spanArr[this.pos] += 1
            this.spanArr.push(0)
          } else {
            this.spanArr.push(1)
            this.pos = i
          }
        }
      }
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2 || columnIndex === 3) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    }
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
      }
    }
  },
  created () {
    this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
    this.onLoadData()
    this.$nextTick(() => {
      let selectDiv = document.getElementsByClassName('select')
      // let tabsDiv = document.getElementsByClassName('tabs')
      this.height = this.$refs['skt'].offsetHeight - selectDiv[0].offsetHeight - 30
    })
  }
}
</script>
<style lang="less" src="@/assets/usercenter.less" scoped></style>
<style lang="less" scoped>
.river { // 水库弹窗样式
   /deep/ .el-dialog {
    width: 500px;
    margin-top: 3vh !important;
  }
  /deep/ .el-dialog__body {
    margin-left: 30px;
  }
  /deep/ .el-form{
    width: 100% !important;
  }
  /deep/.el-form-item {
    width:88% !important;
    // float: left;
  }
  /deep/ .el-form-item__label{
    width: 2.75rem !important;
    white-space: nowrap;
  }
}
.scence /deep/ .el-dialog__body {
  overflow: hidden !important;
}
/deep/ .el-form{
  width: 100% !important;
}
/deep/.el-form-item {
  width: 50% !important;
  float: left;
}
/deep/ .el-form-item__label{
  width: 100px !important;
}
.skt{
  height: calc(100% - 0px) !important;
}
.tabs{
  margin-bottom: 10px;
  height: 62px;
  background-color: #ffffff;
  border-radius: 5px;
  color: #444444;
  font-size: 15px;
  .country{
    float: left;
    font-family: Microsoft YaHei UI;
    font-size: 15px;
    text-align: center;
    margin-top: 20px;
    margin-left: 0.5%;
    cursor: pointer;
    .countryon, .categoryon{
      border-radius: 15px;
      background-color: #fda72c;
      color: #ffffff
    }
    span{
      padding: 4px 15px;
    }
  }
}
.note {
  color: #aaa;
  margin-left: 50px;
}
.app-container{
  width: 100%;
  height: 880px;
  position: relative;
  top: -80px;
  .filter-container {
    width: 100%;
    height: 80px;
    background: #ffffff;
    padding: 15px;
    margin-bottom: 15px;
    border-radius: 5px;
  }
  .el-table{
    background: #ffffff;
    border-radius: 5px;
  }
}
.operation{
  margin: 0!important;
}
// 水位时间设置增加样式
.add-time{
  position: absolute;
  left: 25rem;
  top: 2.5rem;
}
.time-block /deep/ .el-date-picker{
  margin-right: 0.1rem;
  margin-left: 0.4rem;
}
.time-floodlimit{
  height: 1.5rem;
}
.time-floodlimit  #floodLimit {
 width: 40% !important;
}
.time-floodlimit .el-icon-delete{
  position: relative;
  left: 25rem;
  bottom: 1.5rem;
}
</style>
